var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-wrapper",class:{
    'bg-surface': !_vm.dark,
    'bg-black': _vm.dark,
    absolute: !_vm.relative,
    floating: _vm.float,
  },style:(_vm.computedStyle)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }